// client/src/pages/admin/desksColors.ts
// Color coding for the Desks board — by OFFICE and by DEPARTMENT/type.

// Office CODE -> color. Mirrors the PTO OFFICES palette (ptoConstants.ts), keyed by
// PE office code, with FHP (Fairhope) added since it appears on jobs.
const OFFICE_COLORS: Record<string, string> = {
  BHM: '#4a9ead', // Birmingham
  MOB: '#c05a7a', // Mobile
  HSV: '#4aad6a', // Huntsville
  GAD: '#c0a040', // Gadsden
  RGD: '#c06060', // Ridgeland
  FHP: '#7b8cde', // Fairhope
};

export function officeColor(code: string | undefined): string {
  return OFFICE_COLORS[(code || '').toUpperCase()] || '#8090a0';
}

// Department CODE -> color. Covers the real Job_Dept / StaffDepartment values;
// anything unmapped (incl. UNKNOWN) falls back to a neutral grey.
const DEPT_COLORS: Record<string, string> = {
  TAX:     '#7aa2ff',
  AUDIT:   '#57d38c',
  CAS:     '#64d2ff',
  GENERAL: '#bb9af7',
  XGEN:    '#ff9e64',
  ESTATE:  '#c0a040',
  CONSULT: '#4ad0c0',
  ADMINGA: '#e06c9f',
  ADVISORY:'#4ad0c0',
};

export function deptColor(code: string | undefined): string {
  return DEPT_COLORS[(code || '').toUpperCase()] || '#8090a0';
}

// Delivery process (PE Assembly/Shipping questionnaire) → tag color.
export function deliveryColor(mode: string | undefined): string {
  if (mode === 'electronic') return '#22c55e'; // green
  if (mode === 'paper')      return '#ef4444'; // red
  return '#8090a0';                            // not set
}

// Assembly / shipping step status → accent for the per-step line on the card.
export function stepColor(status: string | undefined): string {
  if (status === 'active') return '#f0883e'; // orange — the job is at this step now
  if (status === 'done')   return '#57d38c'; // green
  return '#8090a0';                          // pending
}

// PE work-stage → accent for the on-card PE-status chip. Assembly/Shipping keep the
// vivid colors of the columns they used to have, and SP Binder Creation gets its own,
// so they stand out; any other PE status is a neutral grey.
export function peStageColor(peStage: string | undefined): string {
  if (peStage === 'assembly') return '#4ad0c0'; // teal — was the Assembly column
  if (peStage === 'shipping') return '#f0883e'; // orange — was the Shipping column
  if (peStage === 'binder')   return '#f472b6'; // pink — SP Binder Creation
  return '#8090a0';
}
